module.exports = __webpack_public_path__ + "img/flower-05.78dccbf3.png";